export default __webpack_public_path__ + "static/media/mobReservation.98d7c8c6.png";